@import './pk-checkbox.variables';

:host {
  @apply relative inline-flex h-[var(--checkbox--size)] w-auto min-w-[var(--checkbox--size)] items-center;

  &:hover:not(.is-disabled) input ~ .checkbox-custom {
    filter: brightness(120%);
  }

  &:active:not(.is-disabled) input ~ .checkbox-custom {
    filter: brightness(90%);
  }
}

:host(.is-disabled) {
  @apply opacity-40;
}

input {
  @apply absolute opacity-0;
}

%checkbox-states {
  @apply bg-[color:var(--checkbox--background-color)] opacity-100;
  @apply border-[length:var(--pk-border-radius-sm)] border-solid border-[color:var(--checkbox--background-color)];
}

.checkbox-states {
  @extend %checkbox-states;
}

.checkbox-custom {
  @apply absolute left-0 top-0 h-[var(--checkbox--size-sm)] w-[var(--checkbox--size-sm)] rounded-s bg-[color:var(--checkbox--check-color)];
  @apply border-[length:var(--pk-border-radius-sm)] border-solid border-[color:var(--checkbox--uncheck-border)];

  @include transition(#{background-color, filter});
}

input:checked ~ .checkbox-custom {
  @extend %checkbox-states;

  &::after {
    content: '';
    @apply absolute left-[6px] top-[-2px] h-[17px] w-[6px] rounded-none bg-transparent opacity-100;
    @apply rotate-45 scale-100 border-0 border-b-2 border-r-2 border-solid border-[color:var(--checkbox--check-color)];
  }
}

input:not(:disabled):focus-visible ~ .checkbox-custom {
  @apply focus-outline;
}

input:indeterminate ~ .checkbox-custom {
  @extend %checkbox-states;

  &::after {
    content: '';
    @apply absolute left-[50%] top-[50%] h-[15px] rounded-none bg-transparent opacity-100;
    @apply -translate-x-2/4 -translate-y-2/4 rotate-90 scale-100 border-0 border-b-2 border-r-2 border-solid border-[color:var(--checkbox--check-color)];
  }
}

.checkbox-text {
  @apply ml-[40px] select-none text-[length:var(--checkbox--label-font-size)] text-[color:var(--checkbox--label-color)];

  font-family: var(--checkbox--label-font);
}
